import { render, staticRenderFns } from "./PatientDataHomePage.vue?vue&type=template&id=1bf606fa&scoped=true"
import script from "./PatientDataHomePage.vue?vue&type=script&lang=js"
export * from "./PatientDataHomePage.vue?vue&type=script&lang=js"
import style0 from "./PatientDataHomePage.vue?vue&type=style&index=0&id=1bf606fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf606fa",
  null
  
)

export default component.exports